import styled from 'styled-components'
import { Image, Card, Dropdown, Grid } from 'semantic-ui-react'

import { BasedBodyContainer, BasedFullWidthBackgroundContainer } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)`
    & .list.bulleted>.item:before {
        color: #f67e04;
    }
`
export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #ffe8d1;
`

export const ThemedText = styled.span`
    color: #f67e04;
`

export const Email = styled.a`
    color: inherit;
    cursor: pointer;
    &:hover {
        color: #f67e04;
    }
`

export const Phone = styled(Email)``

export const CenterText = styled.div`
    text-align: center;
`   
export const CustomImage = styled(Image)`
    &&&& {
        width: ${({ $width }) => $width};
        height: ${({ $height }) => $height};
        margin: ${({ $margin }) => $margin};
    }
`
export const At = styled.span`
    font-size: 1.3em;
    font-weight: bold;
    margin-right: .25em;
    cursor: alias;
    user-select: none
`

export const StatsCards = styled(Card.Group)`
    &&& {
        @media (min-width: 768px) {
            margin-left: .5em;
            margin-right: 0;
        }

        &>.ui.card {
            background-color: #ffe8d1;
        }
    }
`
type StatsHeaderProps = {
    $fontSize?: string,
}

export const StatsHeader = styled.span<StatsHeaderProps>`
    font-size: ${({ $fontSize }) => $fontSize};
    line-height: 1.4em;
    @media (max-width: 991px) {
        line-height: inherit;
        &>* {
            font-size: .6em;
        }
    }
`

export const FlexBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: .22em;
`

export const LinkCard = styled(Card)`
    color: rgba(0,0,0,.87);
    &&&&:hover {
        box-shadow: 0 1px 3px 0 #f67e04, 0 0 0 1px #f67e04;
    }
`